import React from "react";
import { Alert, AlertProps } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";

export interface CustomAlertProps extends Omit<AlertProps, "sx"> {
  customColor?: string;
  customFontSize?: string | number;
  customFontWeight?: string | number;
  sx?: SxProps<Theme>;
}

export const CustomAlert = ({
  customColor,
  customFontSize,
  customFontWeight,
  sx,
  className,
  children,
  ...props
}: CustomAlertProps) => {
  const customStyle: React.CSSProperties = {
    ...(customColor ? { color: customColor } : {}),
    ...(customFontSize ? { fontSize: customFontSize } : {}),
    ...(customFontWeight ? { fontWeight: customFontWeight } : {}),
  };

  return (
    <Alert {...props} className={className} style={customStyle} sx={sx}>
      {children}
    </Alert>
  );
};